webpackJsonp([215569955439210],{

/***/ 916:
/***/ (function(module, exports) {

	module.exports = {"data":{"themenJson":{"thema":"shadow","monat_num":3,"thema_cover_uri":"03_2007.jpg","jahr":2007,"monat":"March","id":"thema_61","issue_date":"200703","moving_image_count":1,"still_image_count":3,"textz_count":1,"soundz_count":0}},"pathContext":{"id":"thema_61"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200703-bb267822535173707614.js